
export const searchForm = {
  title: '',
  label_name: '',
  end_time: '',
  start_time: '',
  line_id: undefined,
  status: undefined
}

export const form = {
  title: '',
  line_id: undefined,
  show_position: [],
  url: '',
  sort: '',
  target: undefined,
  description: '',
  status: 1,
  end_at: ''
}

export const rules = {
  line_id: [{ required: true, message: '请选择发布平台', trigger: 'change' }],
  sort: [{ required: true, message: '请输入排序', trigger: 'change' }],
  title: [{ required: true, message: '请输入展示名称', trigger: 'change' }],
  url: [{ required: true, message: '请输入链接地址', trigger: 'change' }],
  target: [{ required: true, message: '请选择打开方式', trigger: 'change' }],
  description: [{ required: true, message: '请输入描述', trigger: 'change' }],
  status: [{ required: true, message: '请选择状态', trigger: 'change' }],
  // end_at: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
  show_position: [{ required: true, message: '请选择展示位置', trigger: 'change' }],
}

export const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'org',
    width: 260,
    align: 'left',
    scopedSlots: { customRender: 'org' }
  },
  {
    title: '排序',
    dataIndex: 'sort',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'sort' }
  },
  {
    title: '链接名称',
    dataIndex: 'title',
    width: 270,
    align: 'left'
  },
  {
    title: '展示位置',
    dataIndex: 'show_position',
    align: 'left',
    width: 280,
    scopedSlots: { customRender: 'show_position' }
  },
  {
    title: '跳转地址',
    dataIndex: 'url',
    align: 'left',
    width: 300,
    scopedSlots: { customRender: 'url' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 80,
    align: 'left',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 120,
    fixed: 'right',
    scopedSlots: { customRender: 'operator' }
  }
]
